import styled from 'styled-components';

const StyledSpan = styled.span`
  font-weight: 400;
`;

export default StyledSpan;
